class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this))
      .observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

        // notify other scripts if needed
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => console.error(e));
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    this.drawer.openMenuDrawer();
  }

  // new: create a temporary toast notification
  showPopup() {
    const popup = document.getElementById('cart-toast');
    const button = document.getElementById('view-cart-button');
    const clgBtn = document.getElementById('close-popup');
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }


    // Ensure it's hidden until we animate
    popup.hidden = false;
    popup.classList.remove('visible');

    // Make sure click always opens drawer
    button.onclick = () => {
      this.open();
      popup.classList.remove('visible');
    };
    clgBtn.onclick = () => {
      popup.classList.remove('visible');
    };

    // Animate in
    requestAnimationFrame(() => popup.classList.add('visible'));

    // Hide after 6s
    setTimeout(() => {
      popup.classList.remove('visible');
      popup.addEventListener('transitionend', () => {
        popup.hidden = true;
      }, { once: true });
    }, 6000);
  }



  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    const enablePopup = document.getElementById('cart-toast');
    if (enablePopup) {
      this.showPopup();
    }
    else {
      this.open();
    }
    // instead of opening the drawer…

  }


  cart_enableLoading() {
    console.log('enabling loader')
    const cart_drawer = document.getElementById('mini-cart');
    if (cart_drawer) cart_drawer.classList.add('cart__items--disableddd');
  }

  cart_disableLoading() {
    const cart_drawer = document.getElementById('mini-cart');
    if (cart_drawer) cart_drawer.classList.remove('cart__items--disableddd');
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)
      .innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);

document.addEventListener('DOMContentLoaded', function () {

  if (window.__giftScriptInitialized) return;
  window.__giftScriptInitialized = true;

  const max_selected = parseInt(window.tiered_gifts.max_selected || 0);
  const gwp_min_spend_a = parseInt(window.tiered_gifts.gwp_min_spend_a || 0);
  const gwp_min_spend_b = parseInt(window.tiered_gifts.gwp_min_spend_b || 0);
  const gwp_min_spend_c = parseInt(window.tiered_gifts.gwp_min_spend_c || 0);

  function forceEnableAllAddButtons() {
    document.querySelectorAll('.gift-add-btn').forEach(btn => {
      btn.disabled = false;
      btn.removeAttribute('disabled');
      btn.style.pointerEvents = 'auto';
      btn.style.opacity = '1';
      btn.style.cursor = 'pointer';
      btn.classList.remove('disabled');
    });
  }

  function startButtonMonitoring() {
    setInterval(forceEnableAllAddButtons, 1000);
  }

  setTimeout(forceEnableAllAddButtons, 500);
  setTimeout(startButtonMonitoring, 1000);

// Debounce flag to prevent multiple simultaneous checks
let isCheckingGifts = false;
let checkGiftsTimeout = null;

async function checkAndAutoRemoveInvalidGifts() {
  // Prevent multiple simultaneous checks
  if (isCheckingGifts) return;
  
  // Debounce: clear any pending checks
  if (checkGiftsTimeout) {
    clearTimeout(checkGiftsTimeout);
  }
  
  checkGiftsTimeout = setTimeout(async () => {
    isCheckingGifts = true;
    try {
      const cart = await fetch('/cart.js').then(res => res.json());
      const cartTotal = cart.total_price / 100;

      const giftItems = cart.items.filter(item => item.properties && item.properties._campaign_type === 'manual_gwp');
      const hasNonGiftItems = cart.items.some(item => !(item.properties && item.properties._campaign_type));

      const invalidGifts = cart.items.filter(item => {
        if (!item.properties || !item.properties._min_price) return false;

        const minPrice = parseInt(item.properties._min_price);

        const shouldRemove =
          (!hasNonGiftItems || cartTotal === 0) ||
          (minPrice === gwp_min_spend_a && cartTotal < gwp_min_spend_a) ||
          (minPrice === gwp_min_spend_b && cartTotal < gwp_min_spend_b) ||
          (minPrice === gwp_min_spend_c && cartTotal < gwp_min_spend_c);

        return shouldRemove;
      });

      if (invalidGifts.length > 0) {
        await Promise.all(invalidGifts.map(item => removeGiftByKey(item.key)));
        // Refresh cart after removing invalid gifts
        refreshCartDrawer(true);
      }

      waitForElement('.add-count', () => {
        updateAddCountDisplayFromCart(giftItems.length - invalidGifts.length);
      });
    } finally {
      isCheckingGifts = false;
    }
  }, 300); // 300ms debounce
}



  checkAndAutoRemoveInvalidGifts(); // 🔁 Run on load
  
  // Debounced event listener to prevent excessive calls
  let cartUpdateTimeout = null;
  document.addEventListener('cart:updated', () => {
    if (cartUpdateTimeout) {
      clearTimeout(cartUpdateTimeout);
    }
    cartUpdateTimeout = setTimeout(() => {
      checkAndAutoRemoveInvalidGifts();
    }, 500); // Wait 500ms after last cart update
  });

 

  function getCurrentGiftButtons() {
    return Array.from(document.querySelectorAll('.gift-remove-btn'));
  }

  function getCurrentGiftCount() {
    return getCurrentGiftButtons().length;
  }

  function updateAddCountDisplay() {
    const count = getCurrentGiftCount();
    document.querySelectorAll('.add-count').forEach(el => {
      el.textContent = count;
    });
  }

  function updateAddCountDisplayFromCart(count) {
    document.querySelectorAll('.add-count').forEach(el => {
      el.textContent = count;
    });
  }

  function waitForElement(selector, callback) {
    const checkExist = setInterval(() => {
      if (document.querySelector(selector)) {
        clearInterval(checkExist);
        callback();
      }
    }, 100);
  }

async function removeGiftByKey(lineItemKey) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineItemKey, quantity: 0 })
    });

    updateAllGiftButtonStates();
    updateAddCountDisplay();
    // Don't call refreshCartDrawer here to avoid event loop - let the caller handle it
  } catch (err) {
    console.error('❌ Error auto-removing gift:', err);
  }
}


  // Flag to prevent refresh loops
  let isRefreshing = false;
  let refreshTimeout = null;

  function refreshCartDrawer(skipEvent = false) {
    // Prevent multiple simultaneous refreshes
    if (isRefreshing) return;
    
    // Debounce refreshes
    if (refreshTimeout) {
      clearTimeout(refreshTimeout);
    }
    
    refreshTimeout = setTimeout(() => {
      isRefreshing = true;
      const sectionList = window.miniCart?.getSectionsToRender?.() || [];
      const sectionIds = sectionList.map((section) => section.id);

      if (!sectionIds.length) {
        console.warn("No cart sections to refresh");
        fetch("/cart.js")
          .then((res) => res.json())
          .then((cart) => {
            if (!skipEvent) {
              document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
            }
            isRefreshing = false;
          });
        return;
      }

      fetch(`/cart?sections=${sectionIds.join(",")}`)
        .then((res) => res.json())
        .then((htmlSections) => {
          return fetch("/cart.js").then((cartRes) => {
            return cartRes.json().then((cart) => {
              cart.sections = htmlSections;
              if (window.miniCart && typeof miniCart.renderContents === "function") {
                miniCart.renderContents(cart);
              }
              if (!skipEvent) {
                document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
              }
              isRefreshing = false;
            });
          });
        })
        .catch(() => {
          isRefreshing = false;
        });
    }, 200); // 200ms debounce
  }

  function removeGiftByButton(btn) {
    return new Promise((resolve, reject) => {
      const lineItemKey = btn.getAttribute('data-line-item-key');
      if (!lineItemKey) return reject("No line item key found");

      btn.textContent = 'Removing...';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineItemKey, quantity: 0 })
      })
        .then(res => res.json())
        .then(() => {
          btn.textContent = 'Add';
          btn.classList.remove('gift-remove-btn');
          btn.classList.add('gift-add-btn');
          btn.removeAttribute('data-line-item-key');
          btn.disabled = false;

          updateAllGiftButtonStates();
          updateAddCountDisplay();
          resolve();
        })
        .catch(err => {
          console.error("❌ Error removing gift:", err);
          btn.textContent = 'Error';
          btn.disabled = false;
          reject(err);
        });
    });
  }

  function updateAllGiftButtonStates() {
    const currentCount = getCurrentGiftCount();

    document.querySelectorAll('.gift-item').forEach(giftItem => {
      const addBtn = giftItem.querySelector('.gift-add-btn');
      const removeBtn = giftItem.querySelector('.gift-remove-btn');

      if (addBtn) {
        addBtn.disabled = false;
        addBtn.removeAttribute('disabled');
        addBtn.style.pointerEvents = 'auto';
        addBtn.style.opacity = '1';
        addBtn.style.cursor = 'pointer';
        addBtn.classList.remove('disabled');
      }

      if (removeBtn) {
        removeBtn.disabled = false;
        removeBtn.removeAttribute('disabled');
        removeBtn.style.pointerEvents = 'auto';
        removeBtn.style.opacity = '1';
        removeBtn.style.cursor = 'pointer';
        removeBtn.classList.remove('disabled');
      }
    });
  }

  // Flag to prevent duplicate add operations
  let isAddingGift = false;
  const pendingAdds = new Set();

  document.body.addEventListener('click', async function (e) {
    if (e.target.classList.contains('gift-add-btn')) {
      // Prevent duplicate clicks
      if (isAddingGift || e.target.disabled) return;
      
      const btn = e.target;
      const giftItem = btn.closest('.gift-item');
      const variantId = giftItem.getAttribute('data-variant-id');
      
      // Check if this variant is already being added
      if (pendingAdds.has(variantId)) return;
      
      // Check if this gift is already in the cart
      try {
        const cart = await fetch('/cart.js').then(res => res.json());
        const isAlreadyInCart = cart.items.some(item => 
          item.variant_id == variantId && 
          item.properties && 
          item.properties._campaign_type === 'manual_gwp'
        );
        
        if (isAlreadyInCart) {
          // Gift already in cart, update button state
          btn.textContent = 'Remove';
          btn.classList.remove('gift-add-btn');
          btn.classList.add('gift-remove-btn');
          const existingItem = cart.items.find(item => 
            item.variant_id == variantId && 
            item.properties && 
            item.properties._campaign_type === 'manual_gwp'
          );
          if (existingItem) {
            btn.setAttribute('data-line-item-key', existingItem.key);
          }
          updateAllGiftButtonStates();
          updateAddCountDisplay();
          return;
        }
      } catch (err) {
        console.error('Error checking cart:', err);
      }

      isAddingGift = true;
      pendingAdds.add(variantId);
      
      const currentCount = getCurrentGiftCount();

      if (currentCount >= max_selected) {
        const firstGiftBtn = getCurrentGiftButtons()[0];
        if (firstGiftBtn) {
          try {
            await removeGiftByButton(firstGiftBtn);
          } catch (err) {
            alert("Couldn't remove existing gift. Try again.");
            isAddingGift = false;
            pendingAdds.delete(variantId);
            return;
          }
        }
      }

      const campaignType = giftItem.getAttribute('data-campaign-type') || 'manual_gwp';
      const minPrice = giftItem.getAttribute('data-min-price') || '';

      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            _campaign_type: campaignType,
            _min_price: minPrice
          }
        })
      })
        .then(res => res.json())
        .then(data => {
          // Check for errors in response
          if (data.status && data.status !== 200) {
            throw new Error(data.description || 'Failed to add gift');
          }
          
          btn.textContent = 'Remove';
          btn.classList.remove('gift-add-btn');
          btn.classList.add('gift-remove-btn');
          btn.setAttribute('data-line-item-key', data.key);
          btn.disabled = false;

          updateAllGiftButtonStates();
          updateAddCountDisplay();
          // Skip event dispatch to prevent loop - checkAndAutoRemoveInvalidGifts will run separately
          refreshCartDrawer(true);
          
          // Manually trigger check after a delay to avoid race conditions
          setTimeout(() => {
            checkAndAutoRemoveInvalidGifts();
          }, 500);

          const miniCart = document.querySelector('mini-cart');
          if (miniCart && typeof miniCart.open === 'function') miniCart.open();
          
          isAddingGift = false;
          pendingAdds.delete(variantId);
        })
        .catch((err) => {
          console.error('Error adding gift:', err);
          btn.textContent = 'Error';
          setTimeout(() => { 
            btn.textContent = 'Add'; 
            btn.disabled = false; 
          }, 2000);
          isAddingGift = false;
          pendingAdds.delete(variantId);
        });
    }

    if (e.target.classList.contains('gift-remove-btn')) {
      // Prevent duplicate clicks
      if (e.target.disabled) return;
      
      const btn = e.target;
      const lineItemKey = btn.getAttribute('data-line-item-key');
      
      if (!lineItemKey) {
        console.error('No line item key found for removal');
        return;
      }
      
      btn.textContent = 'Removing...';
      btn.disabled = true;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineItemKey, quantity: 0 })
      })
        .then(res => res.json())
        .then(() => {
          btn.textContent = 'Add';
          btn.classList.remove('gift-remove-btn');
          btn.classList.add('gift-add-btn');
          btn.removeAttribute('data-line-item-key');
          btn.disabled = false;

          updateAllGiftButtonStates();
          updateAddCountDisplay();
          
          // Skip event dispatch to prevent loop
          refreshCartDrawer(true);
          
          // Manually trigger check after a delay
          setTimeout(() => {
            checkAndAutoRemoveInvalidGifts();
          }, 500);

          const miniCart = document.querySelector('mini-cart');
          if (miniCart && typeof miniCart.open === 'function') miniCart.open();
        })
        .catch((err) => {
          console.error('Error removing gift:', err);
          btn.textContent = 'Error';
          setTimeout(() => { btn.textContent = 'Remove'; btn.disabled = false; }, 2000);
        });
    }
  });
});
